import * as React from "react";
import styled from "styled-components";
import { Icon } from "@blueprintjs/core";
import { Popover2 } from "@blueprintjs/popover2";

export const RightElementIcon = styled(Icon)`
  height: 30px;
  width: 30px;
  margin-top: 3px;
`;

export const ToolTipContainer = styled.div`
  padding: 20px;
`;

export interface IFormToolTipProps {
  text: string;
}

export const FormToolTip: React.FunctionComponent<IFormToolTipProps> = ({
  text,
}) => {
  return (
    <Popover2
      content={<ToolTipContainer>{text}</ToolTipContainer>}
      interactionKind={"hover"}
    >
      <RightElementIcon
        icon={"info-sign"}
        intent={"primary"}
        size={25}
        tabIndex={-1}
      />
    </Popover2>
  );
};
